<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      title="新增上架Profile"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="产品名称">
          <a-input
            v-decorator="['name', {
              rules: [{ required: true, message: '请输入产品名称' }]
            }]"
            placeholder="请输入"
            :max-length="100"
          />
        </a-form-item>

        <a-form-item label="标准价(元)">
          <a-input-number
            style="width: 100%"
            :min="0"
            :precision="3"
            :step="0.001"
            v-decorator="['price', { initialValue: 0 }]"
          />
        </a-form-item>

        <a-form-item label="底价(元)">
          <a-input-number
            style="width: 100%"
            :min="0"
            :precision="3"
            :step="0.001"
            v-decorator="['floor_price', { initialValue: 0 }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { createBaseProfileProduct } from '@/api/base_profile_product'

export default {
  name: 'NewBaseProfileProduct',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'base_profile_product_new' }),
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          const payload = {
            name: values.name,
            price: values.price == null ? 0 : values.price,
            floor_price: values.floor_price == null ? 0 : values.floor_price
          }
          createBaseProfileProduct(payload).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
